import SearchableQuerySelector from "components/shared/SearchableQuerySelector";
import { FETCH_TEAM_CHANNELS } from "pages/teams/graphql";

const sortChannels = (channels = []) =>
  [...channels].sort((a, b) => a.name.localeCompare(b.name));

const MSTeamChannelSelector = ({
  teamId,
  query = FETCH_TEAM_CHANNELS,
  value,
  onChange,
  disabled,
  autoFocus,
  className = "",
}) => {
  if (!teamId) {
    throw new Error("MSTeamChannelSelector requires teamId");
  }

  return (
    <SearchableQuerySelector
      className={className}
      query={query}
      queryVariables={{ teamId }}
      buildQueryVariables={({ queryVariables }) => queryVariables}
      resolveOptions={(data, { searchText }) =>
        sortChannels(data?.teamChannels || []).filter((channel) => {
          if (!searchText) return true;
          const keyword = searchText.toLowerCase();
          return (
            channel.name?.toLowerCase().includes(keyword) ||
            channel.description?.toLowerCase().includes(keyword) ||
            channel.membershipType?.toLowerCase().includes(keyword)
          );
        })
      }
      optionView={(channel) => <div>{channel.name}</div>}
      valueView={value ? <div>{value.name}</div> : null}
      onSelect={onChange}
      disabled={disabled}
      placeholder="Select a channel"
      loadingText="Loading channels..."
      emptyText="No channel found"
      autoFocus={autoFocus}
    />
  );
};

export default MSTeamChannelSelector;
